import { Injectable } from '@angular/core';
import { LocalStorageRepository } from '../repositories/local-storage.repository';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    allowedRoles = ['company', 'admin'];

    modelsPath = {
        Calendar: '/calendar',
        Dashboard: '/',
        Event: '/events',
        Customer: '/customers',
        EventType: '/event-types',
        Organizer: '/organizers',
        RateManagement: '/rate-management',
        Order: '/orders',
        Payment: '/payments',
        StaffGroup: '/staff-groups',
        Staff: '/staff',
        Settings: '/settings/general',
        Log: '/logs',
        SeatTemplate: '/seat-templates',
        SeatType: '/seat-types',
        ClosedDateManagement: '/closed-dates',
        Ticket: '/sales/manual',
        TicketType: '/ticket-types',
        CustomerGroup: '/customer-groups',
        CheckIn: '/check-in'
    };
    private user: any;

    constructor() {
        this.user = LocalStorageRepository.getUser();
    }

    isAccessAllowed(page: string, action: any, requireAdmin = false): boolean {
        if (requireAdmin) {
            return this.user && this.user.role && this.user.role.toLowerCase() === 'admin';
        } else {
            return (
                this.user &&
                (this.hasRole(this.user) ||
                    this.hasPermission(this.user, page, action))
            );
        }
    }

    hasRole(user: any): boolean {
        return user.role && this.allowedRoles.includes(this.user.role);
    }

    hasPermission(user: any, page: string, action: string): boolean {
        console.log(user.permissions);
        return (
            user.permissions &&
            user.permissions[page] &&
            user.permissions[page][action]
        );
    }

    setUser(user: any) {
        this.user = user;
    }

    getAllowedModels() {
        let allowedPermissions = [];

        if (this.user && this.user.permissions) {
            Object.keys(this.user.permissions).forEach((page) => {
                if (this.user.permissions[page]['view']) {
                    allowedPermissions.push(`${page}`);
                }
            });
        }

        return allowedPermissions;
    }
}
